import { render, staticRenderFns } from "./role_form.vue?vue&type=template&id=699f578f&scoped=true&"
import script from "./role_form.vue?vue&type=script&lang=js&"
export * from "./role_form.vue?vue&type=script&lang=js&"
import style0 from "./role_form.vue?vue&type=style&index=0&id=699f578f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699f578f",
  null
  
)

export default component.exports